var map = {
	"./bg.png": "NLbk",
	"./copyright.png": "ryem",
	"./en/btn-1-active.png": "ZtyD",
	"./en/btn-1.png": "27NJ",
	"./en/btn-2-active.png": "f8N0",
	"./en/btn-2.png": "iXk8",
	"./en/img.png": "QHKv",
	"./gd-hbimg.png": "bc0/",
	"./media-active.png": "QbWN",
	"./media.png": "hLVp",
	"./next.png": "J5x9",
	"./prev.png": "2UCg"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "BxNV";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5 ^\.\/.*\.png$
// module id = BxNV
// module chunks = 0